import { FileText } from "lucide-react";

interface ReturnedItem {
  id: string | number;
  product_name: string;
  sku_code?: string;
  quantity: number;
  total_refund: number;
}

interface ReturnedItemsSectionProps {
  items?: ReturnedItem[];
  note?: string;
}

export const ReturnedItemsSection = ({
  items = [],
  note,
}: ReturnedItemsSectionProps) => {
  return (
    <div className="p-4 bg-gray-50/50 border border-gray-100 rounded-lg flex flex-col gap-3">
      <div>
        <h4 className="text-xs font-bold text-gray-600 uppercase tracking-wide mb-2">
          Returned Items
        </h4>

        <div className="grid grid-cols-1 md:grid-cols-2 gap-2">
          {items.length > 0 ? (
            items.map((item) => (
              <div
                key={item.id}
                className="bg-white p-2.5 border border-gray-100 rounded-md flex justify-between items-center text-xs"
              >
                <div>
                  <p className="font-semibold text-gray-800">
                    {item.product_name}
                  </p>

                  <p className="text-[10px] text-gray-400">
                    SKU: {item.sku_code || "-"}
                  </p>
                </div>

                <div className="text-right">
                  <p className="font-bold text-gray-700">
                    Qty: {item.quantity}
                  </p>

                  <p className="text-[10px] text-rose-600 font-medium">
                    Refund: LKR{" "}
                    {item.total_refund.toLocaleString(undefined, {
                      minimumFractionDigits: 2,
                    })}
                  </p>
                </div>
              </div>
            ))
          ) : (
            <p className="text-xs text-gray-400">No items listed.</p>
          )}
        </div>
      </div>

      {note && (
        <div className="border-t border-gray-100 pt-2 flex items-start gap-1 text-xs text-gray-500">
          <FileText className="w-4 h-4 text-gray-400 mt-0.5 flex-shrink-0" />
          <span>
            <strong>Note:</strong> {note}
          </span>
        </div>
      )}
    </div>
  );
};
